import $ from 'jquery';

export default function() {
  //case ea-section-product page
  var blocks = $('.section-product_block');
  for (var i = 0; i < blocks.length; i++) {
    $(".section-product_block" + i).click(function(){
      var id = this.id;
      var option = $(this).data('option-title');
      $(".product_img").attr("src", id); 
      $("[data-option-name]").text(option);

      $('.section-image_blockicon').removeClass('checked');
      $(this).find(".section-image_blockicon").addClass('checked');
    });
  }
  //case product-form page
  var features = $('.product-benefits');
    $(document).on('click', '.product-benefits', function(){
      var option = $(this).attr('data-product-description');
      var $target = $("#produc-feature_content");
      if($(window).width() <768) {
        $target = $("#produc-feature_content");
      }
      if($(this).attr('data-type') == 'desc') {
        option = $("[data-product-desc]").html();
        $target.attr('data-content-type', 'desc');
      } else {
        $target.removeAttr('data-content-type');
      }
      $target.html(option);
      $('.product-benefits').removeClass('checked');
      $(this).addClass('checked');
    });
}